var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.parentData)?_c('div',[_c('PercentTable',{attrs:{"data":_vm.parentData}}),_vm._l((_vm.childItems),function(childItem,index){return _c('PercentTable',{key:`d-${index}`,attrs:{"data":childItem}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }